import { TAftnContentType } from "@naviair-utm/node-shared-interfaces";

export const contentHeaderMapping: { [key: string]: TAftnContentType } = {
    SA: 'METAR',
    SP: 'SPECI',
    FC: 'TAF',
    FT: 'TAF',
    WS: 'SIGMET',
    WC: 'SIGMET',
    WV: 'SIGMET',
    WA: 'UNKNOWN', // AIRMET
    FA: 'UNKNOWN', // GAMET
    UA: 'AIREP SPECIAL',
    FV: 'UNKNOWN', // Volcanic ash advisory
    FK: 'UNKNOWN', // Tropical cyclone advisory
    FN: 'UNKNOWN' // Space weather advisory
}